<template>
  <div>
    <el-card shadow="hover" style="margin-bottom: 10px" v-show="isClearValivitor">
      <h3>基础信息</h3>
      <div class="warp">
          <page-form :ref-obj.sync="formInfo.ref"
                     permission="goodsManageAdd"
                     :data="formInfo.data"
                     :fileList="formFieldList"
                     :labelWidth="formInfo.labelWidth"
                     :ruleList="formInfo.rules"
                     :submit="submitConfig">
            <template v-slot:form-money>
              <el-input v-model.trim="formInfo.data.money" placeholder="请输入">
                <template slot="append">元</template>
              </el-input>
            </template>
            <template v-slot:form-creatTime>
              <el-date-picker v-model.trim="formInfo.data.creatTime" value-format="yyyy-MM-dd" placeholder="请输入">
              </el-date-picker>
            </template>
            <template v-slot:form-moneyInfo>
              <el-input type="textarea" v-model.trim="formInfo.data.moneyInfo" placeholder="请输入">
              </el-input >
            </template>
          </page-form>
      </div>
      <div class="text">补充凭证：</div>
      <div class="goodsImg" style="margin-left: 100px;">
        <upload-pic ref="upload"
                    :fileIds="formInfo.data.url"
                    :pictureList="formInfo.data.pic"
                    :limit="3"
                    :isDisabled="false"
                    :delet="true"></upload-pic>
      </div>
        <label class="upload-text">建议＜3M，最多3张</label>
    </el-card>

    <el-row type="flex" justify="end" class="page-component" :gutter="12">
      <el-col :span="2">
        <el-button type="primary" @click="submitConfig">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import pageForm from '@/components/Form/Index'
import pageTable from '@/components/Table/Index'
import costMenu from '../../store/costMenu/index.js'
import { GETOTHERCOST, SUPPLIERGETLISTS } from '../../store/costMenu/types.js'
import {CLOSECURRENTTAG} from '../../store/user/types'
import UploadPic from '@/page/assignmentManage/components/uploadImage.vue'
export default {
  name: 'othercost',
  data () {
    return {
      pictureList: [],
      formInfo: {
        ref: null,
        data: {
          supplier: '',
          money: '',
          creatTime: '',
          moneyInfo: '',
          url: [],
          pic: []
        },

        rules: {},
        labelWidth: '120px'
      },
      isClearValivitor: false
    }
  },
  components: {
    pageForm,
    pageTable,
    UploadPic
  },
  watch: {
    OtherCostDetailMark: {
      deep: true,
      handler (val) {
        if (val === 1) {
          costMenu.state.OtherCostDetailMark = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'allcost')
          this.$store.dispatch(CLOSECURRENTTAG, '/costmenu/allcost')
        }
      }
    }
  },
  computed: {
    // 表单验证
    formFieldList () {
      return [
        {label: '供应商：', prop: 'supplier', type: 'select', required: true, options: this.supplierSelect, validator: this.supplierValidator},
        {label: '总金额：', prop: 'money', required: true, type: 'slot', append: '元', validator: this.MoneyValidator},
        {label: '计费时间：', prop: 'creatTime', type: 'slot', required: true, validator: this.timeValidator},
        {label: '费用说明：', prop: 'moneyInfo', type: 'slot', required: true, placeholder: '(必填)请对此项费用来源进行说明，最多200字', validator: this.txtValidator}
      ]
    },
    supplierSelect () {
      return costMenu.state.supplierSelect
    },
    OtherCostDetailMark () {
      return costMenu.state.OtherCostDetailMark
    }
  },
  mounted () {
    // 初始化时间
    this.time()
    // 初始化表单验证
    this.formInfo.rules = this.$initRules(this.formFieldList)
    setTimeout(() => {
      this.formInfo.ref.clearValidate()
      this.isClearValivitor = true
    }, 1)

    // 获取下拉框 - 供应商
    this.$store.dispatch(SUPPLIERGETLISTS, {
      warehouseCode: this.$route.params.warehouseCode
    })
  },
  methods: {
    // 时间
    time () {
      var d = new Date()
      var ye = d.getFullYear()
      var mo = (d.getMonth() + 1).toString().padStart(2, '0')
      var da = d.getDate().toString().padStart(2, '0')
      var time = ye + '-' + mo + '-' + da
      this.formInfo.data.creatTime = time
    },
    handleRemove () {
      this.formInfo.data.url = ''
    },
    // 保存
    submitConfig () {
      this.formInfo.ref.validate((valid) => {
        if (valid) {
          var data = this.formInfo.data
          var params = {
            supplierCode: data.supplier,
            money: data.money,
            ycodCostTime: data.creatTime,
            ycodDesc: data.moneyInfo,
            ycodImg: (data.url).toString(),
            warehouseCode: this.$route.params.warehouseCode
          }
          this.$store.dispatch(GETOTHERCOST, params)
        }
      })
    },
    // 总金额校验
    MoneyValidator (rule, value, callback) {
      if (value) {
        var money = /^\d+(\.\d{0,2})?$/
        if (Number(value) > 0 && Number(value) < 10000 && money.test(value)) {
          callback()
        } else {
          callback(new Error('请输入大于零且小于一万可包含两位小数的数字'))
        }
      } else {
        callback(new Error('请输入总金额'))
      }
    },
    // 供应商校验
    supplierValidator (rule, value, callback) {
      if (value === '') {
        callback(new Error('请选择供应商'))
      } else {
        callback()
      }
    },
    // 计费时间校验
    timeValidator (rule, value, callback) {
      if (value) {
        callback()
      } else {
        callback(new Error('请选择时间'))
      }
    },
    // 费用说明校验
    txtValidator (rule, value, callback) {
      if (value === '') {
        callback(new Error('请对此项费用来源进行说明'))
      } else {
        if (value.length > '200') {
          callback(new Error('费用说明最多200个字'))
        } else {
          callback()
        }
      }
    }
  }
}
</script>

<style scoped>
.warp,.goodsImg {
    display: flex;
    padding: 20px 50px 0
}
.warp >>> .el-form:last-child {
    margin-left: 100px;
}
.warp >>> .el-textarea__inner {
    width: 600px;
    resize: none;
    height: 150px;
}
.warp >>> .el-input{
    width: 200px !important
}
.upload-text{
  margin-left: 150px;
}
.text{
  margin-left: 150px;
}
</style>



// WEBPACK FOOTER //
// src/page/costMenu/OtherCost.vue